import BudgetManagement from "./components/BudgetManagement";
import ExpenseManagement from "./components/ExpenseManagement";
import ReportsAndAnalysis from "./components/ReportsAndAnalysis";
import ViewBudget from "./components/budget_tabs/view_budget";
import ViewExpense from "./components/expense_tabs/view_expense";

const expenseRoutes = [
  {
    path: "/facility/expense_management",
    element: <ExpenseManagement />,
  },
  {
    path: "/facility/expense_management/reports",
    element: <ReportsAndAnalysis />,
  },
  {
    path: "/facility/expense_management/budget",
    element: <BudgetManagement />,
  },
  {
    path: "/facility/expense_and_budget_mgmnt/components/budget_tabs/view_budget/:id",
    element: <ViewBudget />,
  },
  {
    path: "/facility/expense_and_budget_mgmnt/components/expense_tabs/view_expense/:id",
    element: <ViewExpense />,
  },
];

export default expenseRoutes;
